// List of available background videos for Spectator UIs
// Place the corresponding files in the public/ folder (e.g., public/bg1.mp4)
// You can add more filenames to this array to make them available in the Admin UI.
export const BACKGROUND_VIDEOS = [
  'bg1.mp4',
  'bg2.mp4',
  'bg3.mp4',
  'bg4.mp4',
  'bg5.mp4',
  'bg6.mp4',
  'bg7.mp4',
  'bg8.mp4',
  'bg9.mp4',
  'bg10.mp4',
  'bg11.mp4',
  'bg13.mp4',
  'bg15.mp4',
];

export default BACKGROUND_VIDEOS;
